import { showWarningMessage } from "../../../_component/MessageSnack";
import axiosInstance from "../../../_config/AxiosInstance";
import config from "../../../_config/config";
import { authConstants } from "../../constant";

// login
export const sigin_user_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.SIGNIN_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.auth.signin, data);
    if (response.status) {
      dispatch({
        type: authConstants.SIGNIN_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      dispatch(get_user_action());
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.SIGNIN_USER_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e.error || e.message);
  }
};

//signup
export const logout_user_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.LOGOUT_USER_ACTION_REQUEST,
  });
  try {
    await axiosInstance.post(config.auth.logout);
    dispatch({
      type: authConstants.LOGOUT_USER_ACTION_SUCCESS,
      payload: null,
    });
    dispatch(get_user_action());
  } catch (e) {
    dispatch({
      type: authConstants.LOGOUT_USER_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e.error || e.message);
  }
};

export const get_user_action = () => async (dispatch) => {
  dispatch({
    type: authConstants.GET_USER_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.auth.me);
    if (response.status) {
      dispatch({
        type: authConstants.GET_USER_SUCCESS,
        payload: response.data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.GET_USER_FAILURE,
      payload: e?.msg,
    });
    // showWarningMessage(e.error || e.message);
    return false;
  }
};
